import React from 'react';

export default function ViewApplicationModal({
    showViewModal,
    closeViewModal,
    viewData,
    viewLoading,
    pdfLoading,
    pdfModal,
    openPdfModal,
    closePdfModal,
}) {

    if (!showViewModal) return null;

    return (
        <>
            <style>{`
                .view-modal-overlay {
                    position: fixed; top: 0; left: 0;
                    width: 100%; height: 100%;
                    background: rgba(0,0,0,0.5);
                    z-index: 1050;
                    display: flex; align-items: center; justify-content: center;
                    padding: 1rem; box-sizing: border-box;
                }
                .view-modal-dialog {
                    width: 100%; max-width: 860px;height: 90vh;
                    display: flex; flex-direction: column;
                }
                .view-modal-content {
                    height: 100%; display: flex; flex-direction: column;
                    overflow: hidden; border-radius: 10px;
                    box-shadow: 0 8px 32px rgba(0,0,0,0.18);
                }
                .view-modal-header {
                    background: #fff; border-bottom: 2px solid #e9ecef;
                    padding: 0.85rem 1.25rem;
                    display: flex; align-items: center; justify-content: space-between;
                    flex-shrink: 0;
                }
                .view-modal-header .modal-title {
                    font-size: 1rem; font-weight: 700; color: #212529; margin: 0;
                }
                .view-modal-body {
                    overflow-y: auto; flex: 1;
                    padding: 1.25rem; background: #f4f5f7;
                }
                .student-banner {
                    background: #fff; border: 1px solid #e9ecef; border-radius: 10px;
                    padding: 1rem 1.25rem; margin-bottom: 1.25rem;
                    display: flex; gap: 2rem; flex-wrap: wrap; align-items: center;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.06);
                }
                .student-banner .s-item { display: flex; flex-direction: column; }
                .student-banner .s-label {
                    font-size: 0.68rem; text-transform: uppercase;
                    letter-spacing: 0.06em; color: #6c757d; font-weight: 600;
                }
                .student-banner .s-value { font-size: 0.95rem; font-weight: 700; color: #212529; }
                .app-card {
                    background: #fff; border-radius: 10px;
                    box-shadow: 0 1px 4px rgba(0,0,0,0.07);
                    margin-bottom: 1.25rem; overflow: hidden; border: 1px solid #e9ecef;
                }
                .app-card-header {
                    background: #581f37; color: #fff; padding: 0.65rem 1rem;
                    display: flex; justify-content: space-between; align-items: center;
                }
                .app-card-header strong { font-size: 0.9rem; }
                .section-divider {
                    font-size: 0.68rem; font-weight: 700; text-transform: uppercase;
                    letter-spacing: 0.08em; color: #6c757d;
                    padding: 0.6rem 1rem 0.25rem;
                    border-top: 1px solid #f0f0f0; background: #fff;
                }
                .info-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
                    gap: 0.85rem; padding: 0.85rem 1rem 1rem; background: #fff;
                }
                .info-item { display: flex; flex-direction: column; }
                .info-label {
                    font-size: 0.68rem; font-weight: 700; text-transform: uppercase;
                    letter-spacing: 0.05em; color: #6c757d; margin-bottom: 3px;
                }
                .info-value { font-size: 0.88rem; color: #212529; font-weight: 500; }
                .info-value.empty { color: #adb5bd; font-style: italic; font-weight: 400; }
                .badge-status {
                    font-size: 0.70rem; padding: 0.3em 0.7em;
                    border-radius: 20px; font-weight: 600;
                }
                .docs-area { padding: 0.75rem 1rem 1rem; background: #fff; }
                .doc-row {
                    display: flex; align-items: center; justify-content: space-between;
                    background: #f8f9fa; border: 1px solid #e9ecef;
                    border-radius: 6px; padding: 0.5rem 0.75rem; margin-bottom: 0.5rem;
                }
                .doc-row:last-child { margin-bottom: 0; }
                .doc-name {
                    font-size: 0.82rem; color: #495057;
                    display: flex; align-items: center; gap: 0.5rem;
                }
                .view-modal-footer {
                    border-top: 1px solid #e9ecef; background: #fff;
                    padding: 0.75rem 1.25rem;
                    display: flex; justify-content: flex-end; flex-shrink: 0;
                }
                .swal-custom-popup {
                    border-radius: 12px !important;
                    font-family: inherit !important;
                }
                @media (max-width: 768px) {
                    .view-modal-header .modal-title { font-size: 0.9rem; }
                    .info-grid { grid-template-columns: repeat(2, 1fr); }
                    .student-banner { gap: 1rem; }
                }
            `}</style>

            {/* ── View Modal ── */}
            <div className="view-modal-overlay" onClick={closeViewModal}>
                <div className="view-modal-dialog" onClick={e => e.stopPropagation()}>
                    <div className="view-modal-content">

                        {/* Header */}
                        <div className="view-modal-header">
                            <h5 className="modal-title">
                                <i className="fa fa-file-text-o mr-2 text-muted"></i>
                                Application Details
                                {viewData?.student && (
                                    <small style={{ fontSize: '0.78rem', color: '#6c757d', marginLeft: '0.5rem', fontWeight: 500 }}>
                                        — {viewData.student.studentname}
                                    </small>
                                )}
                            </h5>
                            <button type="button" className="btn-close" onClick={closeViewModal} />
                        </div>

                        {/* Body */}
                        <div className="view-modal-body">
                            {viewLoading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-secondary" role="status" />
                                    <p className="mt-3 text-muted" style={{ fontSize: '0.9rem' }}>
                                        Loading application details...
                                    </p>
                                </div>
                            ) : viewData?.applications?.length > 0 ? (
                                <>
                                    {/* Student Banner */}
                                    {viewData.student.user_type != 21 && (
                                        <div className="student-banner">
                                            <div className="s-item">
                                                <span className="s-label">Student Name</span>
                                                <span className="s-value">{viewData.student.studentname}</span>
                                            </div>
                                            <div className="s-item">
                                                <span className="s-label">PRN</span>
                                                <span className="s-value">{viewData.student.prn}</span>
                                            </div>
                                            <div className="s-item">
                                                <span className="s-label">Admission Year</span>
                                                <span className="s-value">{viewData.student.admissionyear}</span>
                                            </div>
                                            <div className="s-item">
                                                <span className="s-label">Admitted Discipline</span>
                                                <span className="s-value">{viewData.student.discipline_name}</span>
                                            </div>
                                        </div>
                                    )}

                                    {/* Application Cards */}
                                    {viewData.applications.map((app) => {
                                        const categoryLabel = app.category_code || '—';
                                        const isRejected = app.application_status === 'rejected_to_candidate';

                                        return (
                                            <div key={app.application_id} className="app-card">

                                                <div className="app-card-header">
                                                    <strong>
                                                        <i className="fa fa-graduation-cap mr-2"></i>
                                                        &nbsp;&nbsp;
                                                        {app.course_name}
                                                        {app.course_code ? ` - ${app.course_code}` : ''}
                                                    </strong>
                                                    <span className="badge-status" style={{
                                                        background: isRejected ? '#dc3545' : '#28a745',
                                                        color: '#fff'
                                                    }}>
                                                        {app.application_label}
                                                    </span>
                                                </div>

                                                <div className="section-divider">Course Details</div>
                                                <div className="info-grid">
                                                    <div className="info-item">
                                                        <span className="info-label">Course Category</span>
                                                        <span className={`info-value ${!app.course_category ? 'empty' : ''}`}>
                                                            {categoryLabel}
                                                        </span>
                                                    </div>
                                                    <div className="info-item">
                                                        <span className="info-label">Course Discipline</span>
                                                        <span className={`info-value ${!app.course_discipline_name ? 'empty' : ''}`}>
                                                            {app.course_discipline_name || 'N/A'}
                                                        </span>
                                                    </div>
                                                    <div className="info-item">
                                                        <span className="info-label">NHEQF Level</span>
                                                        <span className={`info-value ${!app.course_level ? 'empty' : ''}`}>
                                                            {app.course_level || 'N/A'}
                                                        </span>
                                                    </div>
                                                    <div className="info-item">
                                                        <span className="info-label">Platform</span>
                                                        <span className={`info-value ${!app.platform ? 'empty' : ''}`}>
                                                            {app.platform || 'N/A'}
                                                        </span>
                                                    </div>
                                                    <div className="info-item">
                                                        <span className="info-label">Mode</span>
                                                        <span className={`info-value ${!app.mode ? 'empty' : ''}`}>
                                                            {app.mode || 'N/A'}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="section-divider">Grade & Credits</div>
                                                <div className="info-grid">
                                                    <div className="info-item">
                                                        <span className="info-label">Course Credit</span>
                                                        <span className="info-value" style={{ fontWeight: 700 }}>
                                                            {app.acquired_credits ?? '—'}
                                                        </span>
                                                    </div>
                                                    <div className="info-item">
                                                        <span className="info-label">Grade</span>
                                                        <span className={`info-value ${!app.grade ? 'empty' : ''}`}>
                                                            {app.grade || 'N/A'}
                                                        </span>
                                                    </div>
                                                    <div className="info-item">
                                                        <span className="info-label">Grade Point</span>
                                                        <span className={`info-value ${app.grade_point == null ? 'empty' : ''}`}>
                                                            {app.grade_point ?? 'N/A'}
                                                        </span>
                                                    </div>
                                                    <div className="info-item">
                                                        <span className="info-label">Grade Scale</span>
                                                        <span className={`info-value ${!app.grade_scale ? 'empty' : ''}`}>
                                                            {app.grade_scale || 'N/A'}
                                                        </span>
                                                    </div>
                                                    <div className="info-item">
                                                        <span className="info-label">Percentage</span>
                                                        <span className={`info-value ${app.percentage == null ? 'empty' : ''}`}>
                                                            {app.percentage != null ? `${app.percentage}%` : 'N/A'}
                                                        </span>
                                                    </div>
                                                    <div className="info-item">
                                                        <span className="info-label">Applied On</span>
                                                        <span className="info-value">
                                                            {app.created_at
                                                                ? new Date(app.created_at).toLocaleDateString('en-IN', {
                                                                    day: '2-digit', month: 'short', year: 'numeric'
                                                                })
                                                                : '—'}
                                                        </span>
                                                    </div>
                                                </div>

                                                {/* Documents */}
                                                {app.documents?.length > 0 && (() => {
                                                    const certificates = app.documents.filter(d => d.document_type === 'certificate');
                                                    const syllabi = app.documents.filter(d => d.document_type === 'syllabus');

                                                    const renderDocs = (docs) => docs.map((doc, dIdx) => (
                                                        <div key={dIdx} className="doc-row">
                                                            <div className="doc-name">
                                                                <i className="fa fa-file-pdf-o text-danger" style={{ fontSize: '1rem' }}></i>
                                                                <span>
                                                                    {doc.file_name.length > 45
                                                                        ? doc.file_name.substring(0, 45) + '…'
                                                                        : doc.file_name}
                                                                </span>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-outline-secondary"
                                                                style={{ minWidth: '75px', fontSize: '0.8rem' }}
                                                                disabled={pdfLoading[doc.encryptedFile]}
                                                                onClick={() => openPdfModal(doc.encryptedFile, doc.file_name)}
                                                            >
                                                                {pdfLoading[doc.encryptedFile]
                                                                    ? <span className="spinner-border spinner-border-sm" />
                                                                    : <><i className="fa fa-eye mr-1"></i> View</>}
                                                            </button>
                                                        </div>
                                                    ));

                                                    return (
                                                        <>
                                                            {certificates.length > 0 && (
                                                                <>
                                                                    <div className="section-divider">
                                                                        <i className="fa fa-paperclip mr-1"></i> Certificates
                                                                    </div>
                                                                    <div className="docs-area">
                                                                        {renderDocs(certificates)}
                                                                    </div>
                                                                </>
                                                            )}
                                                            {syllabi.length > 0 && (
                                                                <>
                                                                    <div className="section-divider">
                                                                        <i className="fa fa-book mr-1"></i> Syllabus
                                                                    </div>
                                                                    <div className="docs-area">
                                                                        {renderDocs(syllabi)}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </>
                                                    );
                                                })()}
                                            </div>
                                        );
                                    })}
                                </>
                            ) : (
                                !viewLoading && (
                                    <div className="text-center py-5 text-muted">
                                        <i className="fa fa-inbox fa-3x mb-3 d-block" style={{ opacity: 0.25 }}></i>
                                        <p style={{ fontSize: '0.9rem' }}>No application records found.</p>
                                    </div>
                                )
                            )}
                        </div>



                    </div>
                </div>
            </div>


        </>
    );
}